import { render, staticRenderFns } from "./OnboardingJourney.vue?vue&type=template&id=18041f28&scoped=true"
import script from "./OnboardingJourney.vue?vue&type=script&lang=js"
export * from "./OnboardingJourney.vue?vue&type=script&lang=js"
import style0 from "./OnboardingJourney.vue?vue&type=style&index=0&id=18041f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18041f28",
  null
  
)

export default component.exports